import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { User } from 'src/app/models/user';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: "root",
})
export class AuthService {
    constructor(private http: HttpClient) { }

    login(formData): Promise<User> {
        return this.http.post(environment.baseURL + `/auth/login`, { un: formData.email, pwd: formData.password }, {   headers: new HttpHeaders({
            "X_TENANT_ID": "1",
          })})

            .toPromise()
            .then<User>((user: User) => {
                return Promise.resolve(user);
            })
            .catch((err) => {
                return Promise.reject(null);
            });
    }

    loginWithOtp(formData): Promise<User> {
        return this.http.post(environment.baseURL + `/auth/login`, { un: formData.mobile, otp: formData.otp })
            .toPromise()
            .then<User>((user: User) => {
                return Promise.resolve(user);
            })
            .catch((err) => {
                return Promise.reject(null);
            });
    }

    requestOtp(formData): Promise<any> {
        return this.http.post(environment.baseURL + `/auth/login`, { un: formData.mobile, needOtp: true })
            .toPromise()
            .then<any>((response: any) => {
                return Promise.resolve(response);
            })
            .catch((err) => {
                return Promise.reject(null);
            });
    }

    resendOtp(formData): Promise<any> {
        return this.http.post(environment.baseURL + `/auth/login`, { un: formData.mobile, resendOtp: true })
            .toPromise()
            .then<any>((response: any) => {
                return Promise.resolve(response);
            })
            .catch((err) => {
                return Promise.reject(null);
            });
    }


    loginMode(): Promise<any> {
        return this.http.get(environment.baseURL + `/auth/login-mode`)
            .toPromise()
            .then<any>((response: any) => {
                return Promise.resolve(response);
            })
            .catch((err) => {
                return Promise.reject(null);
            });
    }

    resetLink(un): Promise<any> {
        return this.http.get(environment.baseURL + `/auth/sendResetLink/${un}`,{   headers: new HttpHeaders({
            "X_TENANT_ID": "1",
          })})
            .toPromise()
            .then<any>((response: any) => {
                return Promise.resolve(response);
            })
            .catch((err) => {
                return Promise.reject(null);
            });
    }

    sendOtp(username,token): Promise<any> {
        return this.http.post(environment.baseURL + `/auth/sendOtp`, { un: username},{   headers: new HttpHeaders({
            "X_TENANT_ID": "1",
            "TOKEN":token,
          })})
            .toPromise()
            .then<any>((response: any) => {
                return Promise.resolve(response);
            })
            .catch((err) => {
                return Promise.reject(null);
            });
    }

    validateOtp(otp,username,token): Promise<any> {
        return this.http.get(environment.baseURL + `/auth/validateOtp/${otp}/${username}`,{   headers: new HttpHeaders({
            "X_TENANT_ID": "1",
            "TOKEN":token,
          })})
            .toPromise()
            .then<any>((response: any) => {
                return Promise.resolve(response);
            })
            .catch((err) => {
                return Promise.reject(null);
            });
    }

    resetPassword(un,pwd,token): Promise<User> {
        return this.http.put(environment.baseURL + `/auth/resetpassword`, { un: un, pwd: pwd },{   headers: new HttpHeaders({
            "X_TENANT_ID": "1",
            "TOKEN": token,
          })})
            .toPromise()
            .then<User>((user: User) => {
                return Promise.resolve(user);
            })
            .catch((err) => {
                return Promise.reject(null);
            });
    }

    validateToken(token): Promise<any> {
        return this.http.post(environment.baseURL + `/auth/token/validate`, {token: token},{   headers: new HttpHeaders({
            "X_TENANT_ID": "1",
          })})
            .toPromise()
            .then<any>((response: any) => {
                return Promise.resolve(response);
            })
            .catch((err) => {
                return Promise.reject(null);
            });
    }



    getGoogleReviews(req: any): Promise<any> {
        let token = JSON.parse(localStorage.getItem('user'))?.token;
        return this.http.post(environment.baseURL + `/auth/reviews`, req, {
          headers: new HttpHeaders({
            "Authorization": token,
          })
        }) .toPromise()
        .then<any>((result: any) => {
          return Promise.resolve(result);
        })
        .catch((err) => {
          return Promise.reject(null);
        });

      }


    getUserType() {
        return localStorage.getItem("userType");
    }

    canShowWalkin(){

        // const rolePrivilege = JSON.parse(localStorage.getItem('user'))?.reportName;
        // if(rolePrivilege == undefined){
        //     return false;
        // }else{
        //     return true;
        // }

        const rolePrivilege = JSON.parse(localStorage.getItem('user'))?.roles[0];
        return rolePrivilege && (rolePrivilege == 'ISP' || rolePrivilege == 'PARTNER')

    }

    canManage(privilegeName) {
        const rolePrivilege = JSON.parse(localStorage.getItem('user'))?.privileges.filter(p => p.name === privilegeName)[0];

        //if 0 or 1 then no or view privilege. if 2 then can manage privilege
        if (!rolePrivilege) {
            return 0;
        }
        if (rolePrivilege.type === 'VIEW') {
            return 1;
        } else if (rolePrivilege.type === 'MANAGE') {
            return 2;
        }
        return 0;
    }

    canShow(role) : boolean{
     let roleName =   JSON.parse(localStorage.getItem('user'))?.roles[0]
     if(role == roleName){
        return true;
    }else{
        return false;
    }
    }

    canShowIspPartner(){
        let roles =   JSON.parse(localStorage.getItem('user'))?.roles[0]
        if(roles == "PARTNER" || roles == "ISP"){
            return true;
        }else{
            return false;
        }
    }

    canShowIspVoucherRedeemBtn(): boolean {
        let roles =   JSON.parse(localStorage.getItem('user'))?.roles[0];
        const rolePrivilege = JSON.parse(localStorage.getItem('user'))?.privileges.filter(p => p.name === "REDEEM_ON_VALIDATION_LISTING")[0];

        return roles === "ISP" && rolePrivilege?.name === "REDEEM_ON_VALIDATION_LISTING";
    }

    canShowVoucherValidateBtn(): boolean {
        let roles =   JSON.parse(localStorage.getItem('user'))?.roles[0];
        const rolePrivilege = JSON.parse(localStorage.getItem('user'))?.privileges.filter(p => p.name === "VALIDATE_VOUCHER")[0];

        return roles === "ISP" && rolePrivilege?.name === "VALIDATE_VOUCHER";
    }

    canShowAsm(){
        let roles =   JSON.parse(localStorage.getItem('user'))?.roles[0]
        if( roles =="ASM"){
            return true;
        }else{
            return false;
        }
    }
    canShowSpoc(){
        let roles =   JSON.parse(localStorage.getItem('user'))?.roles[0]
        if( roles =="SPOC"){
            return true;
        }else{
            return false;
        }
    }
    canShowServiceIsp(){
        let roles =   JSON.parse(localStorage.getItem('user'))?.roles[0]
        if(roles == "SERVICE_ISP"){
            return true;
        }else{
            return false;
        }
    }
    storeCountChecker(count:number){
        let stores: any[] =   JSON.parse(localStorage.getItem('user'))?.store
        if(stores && stores.length > count){
            return true;
        }else{
            return false;
        }
    }

    headerShow(){
        let roles: any[] =   JSON.parse(localStorage.getItem('user'))?.roles;

        if(roles && roles.length > 0 && roles[0]=="ISP"){
            return true;
        }else{
            return false
        }
    }


    downloadRMNFile(id: string): Promise<any> {
        let token = JSON.parse(localStorage.getItem('user'))?.token;
        return this.http.get(`${environment.baseURL}/admin/stores/rmn/download/${id}`, {
          headers: new HttpHeaders({
            "X_TENANT_ID": "1",
            "Authorization": token
          }),
          responseType: 'blob',
          observe: 'response'
        }).toPromise();
      }


    canShowDashboard(): boolean {
        const rolePrivilege = JSON.parse(localStorage.getItem('user'))?.privileges.find(p => p.name === "DASHBOARD-CAMPAIGN-TAB");
        return rolePrivilege?.name === "DASHBOARD-CAMPAIGN-TAB";
    }

}
